import { de, enGB, es, fr, hu, nl, pt } from 'date-fns/locale'

export default { de, en: enGB, es, fr, hu, nl, pt }
